<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
    >
      <v-toolbar
        flat
        dark
        style="background-color: #d32f2f"
        class="details-applicability-toolbar pb-md-2"
      >
        <div
          class="d-flex flex-column flex-md-row align-stretch align-md-center w-100 px-2 ga-2 justify-md-space-between min-width-0 pt-3 pt-md-0"
        >
          <div
            class="d-flex align-center justify-space-between ga-2 min-width-0 flex-shrink-1"
          >
            <v-toolbar-title
              class="text-white px-0 min-width-0 flex-grow-1 text-body-2 text-md-h6"
              :class="
                $vuetify.display.mdAndDown
                  ? 'text-wrap'
                  : 'text-truncate'
              "
            >
              {{ $t("parts.infoCar.applicability") }}
            </v-toolbar-title>
            <v-btn
              variant="outlined"
              icon
              color="white"
              class="flex-shrink-0 d-md-none"
              @click="close"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>

          <div
            class="d-flex flex-wrap align-center ga-2 flex-md-shrink-0 justify-md-end pb-2 pb-md-0 flex-md-nowrap details-applicability-actions"
          >
            <v-btn
              v-if="
                ($store.getters.role === 'LekoAdmin' ||
                  $store.getters.role === 'SuperAdmin' ||
                  $store.getters.role === 'InstitutionAdmin') &&
                !applicability
              "
              variant="outlined"
              color="white"
              class="mx-0 text-none details-applicability-action-btn"
              :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
              @click="openCustomAppl"
            >
              {{ $t("add_custom_applicability") }}
              <v-icon end>mdi-plus</v-icon>
            </v-btn>
            <v-btn
              v-if="
                ($store.getters.role === 'LekoAdmin' ||
                  $store.getters.role === 'SuperAdmin' ||
                  $store.getters.role === 'InstitutionAdmin') &&
                !applicability &&
                car
              "
              variant="outlined"
              color="white"
              class="mx-0 text-none details-applicability-action-btn"
              :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
              @click="openOriginAppl"
            >
              {{ $t("add_origin_applicability") }}
              <v-icon end>mdi-plus</v-icon>
            </v-btn>
            <v-btn
              v-if="
                ($store.getters.role === 'LekoAdmin' ||
                  $store.getters.role === 'SuperAdmin' ||
                  $store.getters.role === 'LekoEmployee') &&
                applicability
              "
              :loading="loadingDelete"
              variant="outlined"
              color="white"
              class="deleteApplicability mx-0 text-none details-applicability-action-btn"
              :size="$vuetify.display.mdAndUp ? 'default' : 'small'"
              @click="deleteApplicability"
            >
              {{ $t("parts.infoCar.deleteApplicability") }}
            </v-btn>
            <v-btn
              variant="outlined"
              icon
              color="white"
              class="d-none d-md-inline-flex flex-shrink-0 ms-md-1"
              size="large"
              @click="close"
            >
              <v-icon size="large">mdi-close</v-icon>
            </v-btn>
          </div>
        </div>
      </v-toolbar>

      <v-card class="pa-2">
        <!--CAR DETAILS: full-width stack xs–sm; same horizontal layout md+ as before -->
        <!-- Desktop car details (sm+): unchanged horizontal layout -->
        <v-row v-if="car && !$vuetify.display.xs" dense align="start" class="car-details-row pb-8 pa-3">
          <v-col md="auto" class="car-details-icon flex-shrink-0 pt-1 pr-md-2">
            <v-icon color="grey-darken-2"> mdi-car </v-icon>
          </v-col>
          <v-col md="1" lg="1" class="car-details-cell">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.brand") }}</span>
              <span class="font-weight-bold text-break">{{ car.brand.title }}</span>
            </v-row>
          </v-col>
          <v-col md="3" lg="3" class="car-details-cell car-details-model">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.model") }}</span>
              <span class="font-weight-bold text-break">{{ car.model.fullDescription }}</span>
            </v-row>
          </v-col>
          <v-col md="2" lg="2" class="car-details-cell car-details-version">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.version") }}</span>
              <span class="font-weight-bold text-break">{{ car.version.description }}</span>
            </v-row>
          </v-col>
          <v-col md="auto" class="car-details-cell">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.year") }}</span>
              <span class="font-weight-bold text-break">{{ formatMoment(car.version.startingDate) }} - {{ formatMoment(car.version.endingDate) }}</span>
            </v-row>
          </v-col>
          <v-col md="auto" class="car-details-cell">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.body") }}</span>
              <span class="font-weight-bold text-break">{{ car.version.numberOfDoors }}</span>
            </v-row>
          </v-col>
          <v-col md="auto" class="car-details-cell">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.power") }}</span>
              <span class="font-weight-bold text-break">{{ car.version && car.version.power ? car.version.power.kw : "" }} kw</span>
            </v-row>
          </v-col>
          <v-col md="auto" class="car-details-cell">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.engine") }}</span>
              <span class="font-weight-bold text-break">{{ car.version.engineCode }}</span>
            </v-row>
          </v-col>
          <v-col md="auto" class="car-details-cell">
            <v-row class="flex-column ma-0">
              <span class="caption">{{ $t("parts.advanced_search.supply.supply") }}</span>
              <span class="font-weight-bold text-break">{{ getSupplyLocale(car.version.supplyCode) }}</span>
            </v-row>
          </v-col>
        </v-row>

        <!-- Mobile car details (xs): compact label/value rows -->
        <div v-if="car && $vuetify.display.xs" class="car-details-mobile pa-3 pb-2">
          <div class="d-flex align-center mb-2">
            <v-icon color="grey-darken-2" size="20" class="mr-2">mdi-car</v-icon>
            <span class="text-caption text-grey-darken-1">{{ $t("parts.advanced_search.brand") }}</span>
            <span class="font-weight-bold text-body-2 ml-2">{{ car.brand.title }}</span>
          </div>
          <div class="car-details-mobile__row">
            <span class="car-details-mobile__label">{{ $t("parts.advanced_search.model") }}</span>
            <span class="car-details-mobile__value">{{ car.model.fullDescription }}</span>
          </div>
          <div class="car-details-mobile__row">
            <span class="car-details-mobile__label">{{ $t("parts.advanced_search.version") }}</span>
            <span class="car-details-mobile__value">{{ car.version.description }}</span>
          </div>
          <div class="d-flex flex-wrap gap-x-4 mt-1">
            <div class="car-details-mobile__row mr-4">
              <span class="car-details-mobile__label">{{ $t("parts.advanced_search.year") }}</span>
              <span class="car-details-mobile__value">{{ formatMoment(car.version.startingDate) }} - {{ formatMoment(car.version.endingDate) }}</span>
            </div>
            <div class="car-details-mobile__row mr-4">
              <span class="car-details-mobile__label">{{ $t("parts.advanced_search.body") }}</span>
              <span class="car-details-mobile__value">{{ car.version.numberOfDoors }}</span>
            </div>
            <div class="car-details-mobile__row mr-4">
              <span class="car-details-mobile__label">{{ $t("parts.advanced_search.power") }}</span>
              <span class="car-details-mobile__value">{{ car.version && car.version.power ? car.version.power.kw : "" }} kw</span>
            </div>
            <div class="car-details-mobile__row mr-4">
              <span class="car-details-mobile__label">{{ $t("parts.advanced_search.engine") }}</span>
              <span class="car-details-mobile__value">{{ car.version.engineCode }}</span>
            </div>
            <div class="car-details-mobile__row">
              <span class="car-details-mobile__label">{{ $t("parts.advanced_search.supply.supply") }}</span>
              <span class="car-details-mobile__value">{{ getSupplyLocale(car.version.supplyCode) }}</span>
            </div>
          </div>
        </div>
        <div v-if="addFromOrigin">
          <v-col class="d-flex py-0">
            <v-col xs="12" sm="6" xl="4" lg="4" md="4">
              <v-text-field
                v-model="carBrand"
                :label="$t('parts.advanced_search.brand')"
                variant="solo"
                color="red-darken-1"
                hide-details
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col xs="12" sm="12" xl="8" lg="8" md="8">
              <v-text-field
                v-model="carModel"
                :label="$t('parts.advanced_search.model')"
                variant="solo"
                color="red-darken-1"
                readonly
                hide-details
              >
              </v-text-field>
            </v-col>
          </v-col>
          <v-col>
            <v-col xs="12" sm="12" xl="12" lg="12" md="12">
              <v-text-field
                v-model="carVersion"
                :label="$t('parts.advanced_search.version')"
                variant="solo"
                color="red-darken-1"
                hide-details
                readonly
              >
              </v-text-field>
            </v-col>
            <v-col
              xs="12"
              sm="12"
              xl="12"
              lg="12"
              md="12"
              class="text-end justify-end d-flex"
            >
              <v-btn
                color="green darken-1"
                variant="flat"
                class="mx-1"
                :loading="loadingCustom"
                :disabled="!carBrand || !carModel || !carVersion"
                @click="addOriginApplicability"
              >
                {{ $t("save_custom_applicability") }}
              </v-btn>
            </v-col>
          </v-col>
        </div>
        <div v-if="addCustomForm">
          <v-col class="d-flex py-0">
            <v-col xs="12" sm="6" xl="4" lg="4" md="4">
              <v-autocomplete
                v-model="brand"
                :items="brands"
                :loading="loadingBrand"
                :label="$t('parts.advanced_search.brand')"
                item-title="title"
                variant="solo"
                color="red-darken-1"
                hide-details
                return-object
                clearable
              >
                <!-- Custom dropdown item -->
                <template #item="{ props, item }">
                  <v-list-item v-bind="props">
                    <template #prepend>
                      <v-img
                        :src="item.raw.logo"
                        height="35"
                        width="35"
                        class="mr-3"
                        cover
                      />
                    </template>
                    <!-- <v-list-item-title>{{ item.raw.title }}</v-list-item-title> -->
                  </v-list-item>
                </template>

                <!-- Selected value in the field -->
                <template #selection="{ item }">
                  <div class="d-flex align-center">
                    <v-img
                      :src="item.raw.logo"
                      height="35"
                      width="35"
                      class="mr-3"
                      cover
                    />
                    <span>{{ item.raw.title }}</span>
                  </div>
                </template>
              </v-autocomplete>
            </v-col>
            <v-col xs="12" sm="12" xl="8" lg="8" md="8">
              <v-combobox
                v-model="model"
                :items="models"
                :loading="loadingModel"
                :label="!model ? $t('parts.advanced_search.model') : ''"
                item-title="description"
                item-value="modelCode"
                variant="solo"
                color="red-darken-1"
                hide-details
                return-object
                clearable
                @click:append-inner="model = null"
              >
                <!-- Dropdown items -->
                <template #item="{ props, item }">
                  <v-list-item v-bind="props">
                    <v-list-item-content>
                      <div class="d-flex">
                        <!-- Description -->
                        <v-col cols="12" md="4" class="bg-grey-lighten-3 mt-2">
                          <div class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.model")
                            }}</span>
                            <span class="font-weight-bold">{{
                              item.raw.description
                            }}</span>
                          </div>
                        </v-col>

                        <!-- Year range -->
                        <v-col
                          cols="12"
                          md="8"
                          class="d-none d-md-flex bg-grey-lighten-3 mt-2"
                        >
                          <div class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.year")
                            }}</span>
                            <span class="font-weight-bold">
                              {{ formatMonthYear(item.raw.startingDate) }}
                              -
                              {{ formatMonthYear(item.raw.endingDate) }}
                            </span>
                          </div>
                        </v-col>
                      </div>
                    </v-list-item-content>
                  </v-list-item>
                </template>

                <!-- Selected value -->
                <template #selection="{ item }">
                  <div class="d-flex justify-between align-center pa-2">
                    <div class="d-flex flex-column pr-2">
                      <span class="caption">{{
                        $t("parts.advanced_search.model")
                      }}</span>
                      <span class="font-weight-bold">{{
                        item.raw.description
                      }}</span>
                    </div>
                    <div class="d-none d-md-flex flex-column">
                      <span class="caption">{{
                        $t("parts.advanced_search.year")
                      }}</span>
                      <span class="font-weight-bold">
                        {{ formatMonthYear(item.raw.startingDate) }} -
                        {{ formatMonthYear(item.raw.endingDate) }}
                      </span>
                    </div>
                  </div>
                </template>
              </v-combobox>
            </v-col>
          </v-col>
          <v-col>
            <v-col xs="12" sm="12" xl="12" lg="12" md="12">
              <v-combobox
                v-model="version"
                :items="versions"
                :loading="loadingVersion"
                :label="!version ? $t('parts.advanced_search.version') : ''"
                item-title="fullDescription"
                item-value="versionCode"
                variant="solo"
                color="red-darken-1"
                hide-details
                return-object
                clearable
                @click:append-inner="version = null"
              >
                <!-- Dropdown items -->
                <template #item="{ item, props }">
                  <v-list-item v-bind="props">
                    <v-row class="pa-3 bg-grey-lighten-3 mt-2">
                      <v-col>
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.version")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.description
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col class="hidden-sm-and-down">
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </v-row>
                      </v-col>
                      <v-col class="hidden-sm-and-down">
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.body")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.numberOfDoors
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col class="hidden-sm-and-down">
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.power")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ item.raw.power ? item.raw.power.kw : "" }}
                            kw,
                          </span>
                        </v-row>
                      </v-col>
                      <v-col class="hidden-sm-and-down">
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.engine")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.engineCode
                          }}</span>
                        </v-row>
                      </v-col>
                      <v-col class="hidden-sm-and-down">
                        <v-row class="d-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.supply.supply")
                          }}</span>
                          <span class="font-weight-bold">{{
                            getSupplyLocale(item.raw.supplyCode)
                          }}</span>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-list-item>
                </template>

                <!--SELECTED-->
                <template #selection="{ item }">
                  <v-row class="pa-2">
                    <v-col>
                      <v-row class="d-flex flex-column">
                        <span class="caption">
                          {{ $t("parts.advanced_search.version") }}
                        </span>
                        <span class="font-weight-bold">{{
                          item.raw.description
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col class="hidden-sm-and-down">
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.year")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ formatMonthYear(item.raw.startingDate) }} -
                          {{ formatMonthYear(item.raw.endingDate) }}
                        </span>
                      </v-row>
                    </v-col>
                    <v-col class="hidden-sm-and-down">
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.body")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.numberOfDoors
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col class="hidden-sm-and-down">
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.power")
                        }}</span>
                        <span class="font-weight-bold">
                          {{ item.raw.power ? item.raw.power.kw : " " }}
                          kw,
                        </span>
                      </v-row>
                    </v-col>
                    <v-col class="hidden-sm-and-down">
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.engine")
                        }}</span>
                        <span class="font-weight-bold">{{
                          item.raw.engineCode
                        }}</span>
                      </v-row>
                    </v-col>
                    <v-col class="hidden-sm-and-down">
                      <v-row class="d-flex flex-column">
                        <span class="caption">{{
                          $t("parts.advanced_search.supply.supply")
                        }}</span>
                        <span class="font-weight-bold">{{
                          getSupplyLocale(item.raw.supplyCode)
                        }}</span>
                      </v-row>
                    </v-col>
                  </v-row>
                </template>
              </v-combobox>
            </v-col>
            <v-col
              xs="12"
              sm="12"
              xl="12"
              lg="12"
              md="12"
              class="text-end justify-end d-flex"
            >
              <v-btn
                color="green darken-1"
                variant="flat"
                class="mx-1"
                :loading="loadingCustom"
                :disabled="!brand || !model || !version"
                @click="addCustomApplicability"
              >
                {{ $t("save_custom_applicability") }}
              </v-btn>
            </v-col>
          </v-col>
        </div>

        <!-- ═══════════════ MOBILE APPLICABILITY (xs only) ═══════════════ -->
        <div v-if="$vuetify.display.xs && applicability" class="d-sm-none">

          <!-- Custom applicability action buttons -->
          <div v-if="applicability" class="d-flex flex-wrap ga-2 px-3 pt-2 pb-1 justify-end">
            <v-btn
              v-if="customApplicability || part.customApplicability"
              variant="tonal"
              color="error"
              size="small"
            >
              {{ $t("custom_appl_info") }}
            </v-btn>
            <v-btn
              v-if="part.customApplicability"
              variant="outlined"
              color="error"
              size="small"
              @click="editAppl()"
            >
              {{ $t("edit") }}
              <v-icon end>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              v-if="part.customApplicability"
              variant="outlined"
              color="error"
              size="small"
              :loading="loadingCustomDelete"
              @click="openDeleteCustom()"
            >
              {{ $t("delete") }}
              <v-icon end>mdi-delete</v-icon>
            </v-btn>
          </div>

          <!-- Edit form (shown when openEditForm is true) -->
          <div v-if="openEditForm" class="px-3 pb-2">
            <v-autocomplete
              v-model="editBrand"
              :items="brands"
              :loading="loadingBrand"
              :label="$t('parts.advanced_search.brand')"
              item-title="title"
              item-value="brandCode"
              variant="outlined"
              color="red-darken-1"
              hide-details
              return-object
              clearable
              density="compact"
              class="mb-2"
            />
            <v-combobox
              v-model="editModel"
              :items="models"
              :loading="loadingModel"
              :label="!editModel ? $t('parts.advanced_search.model') : ''"
              item-title="description"
              item-value="modelCode"
              variant="outlined"
              color="red-darken-1"
              hide-details
              return-object
              clearable
              density="compact"
              class="mb-2"
            />
            <v-combobox
              v-model="editVersion"
              :items="versions"
              :loading="loadingVersion"
              :label="!editVersion ? $t('parts.advanced_search.version') : ''"
              item-title="fullDescription"
              item-value="versionCode"
              variant="outlined"
              color="red-darken-1"
              hide-details
              return-object
              clearable
              density="compact"
              class="mb-2"
            />
            <div class="d-flex justify-end">
              <v-btn
                color="green"
                variant="flat"
                size="small"
                :loading="loadingEdit"
                :disabled="!editBrand || !editModel || !editVersion"
                @click="editCustomAppl()"
              >
                {{ $t("edit_custom_applicability") }}
              </v-btn>
            </div>
          </div>

          <!-- Level 1: flat list of brand / model / year -->
          <div v-if="!mobileSelectedAppl">
            <!-- column headers -->
            <v-row no-gutters class="px-3 py-1 bg-grey-lighten-3 text-caption text-grey-darken-1 font-weight-bold">
              <v-col cols="4">{{ $t('parts.infoCar.brand') }}</v-col>
              <v-col cols="4">{{ $t('parts.advanced_search.model') }}</v-col>
              <v-col cols="4">{{ $t('parts.infoCar.year') }}</v-col>
            </v-row>
            <div
              v-for="(item, index) in applicability"
              :key="index"
              class="appl-mobile-row"
              @click="mobileSelectedAppl = item"
            >
              <v-row no-gutters align="center" class="px-3 py-3">
                <v-col cols="4" class="text-body-2 font-weight-medium">{{ item.brand }}</v-col>
                <v-col cols="4" class="text-body-2">{{ item.modelId && item.modelId.description }}</v-col>
                <v-col cols="3" class="text-body-2 text-caption">
                  {{ formatMoment(item.modelId && item.modelId.startingDate) }}
                  <template v-if="item.modelId && item.modelId.endingDate"> - {{ formatMoment(item.modelId.endingDate) }}</template>
                </v-col>
                <v-col cols="1" class="text-right">
                  <v-icon size="18" color="grey">mdi-chevron-right</v-icon>
                </v-col>
              </v-row>
              <v-divider />
            </div>
          </div>

          <!-- Level 2: version detail for selected row -->
          <div v-else>
            <div class="d-flex align-center px-2 py-2 bg-grey-lighten-4">
              <v-btn variant="text" icon size="small" @click="mobileSelectedAppl = null">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <span class="text-body-2 font-weight-bold ml-1">
                {{ mobileSelectedAppl.brand }} – {{ mobileSelectedAppl.modelId && mobileSelectedAppl.modelId.description }}
              </span>
            </div>
            <v-divider />
            <div>
              <table class="appl-mobile-version-table">
                <thead>
                  <tr>
                    <th>{{ $t('parts.infoCar.version') }}</th>
                    <th>{{ $t('parts.infoCar.year') }}</th>
                    <th>{{ $t('parts.infoCar.body') }}</th>
                    <th>{{ $t('parts.infoCar.power') }}</th>
                    <th>{{ $t('parts.infoCar.engine') }}</th>
                    <th>{{ $t('parts.advanced_search.supply.supply') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(ver, vi) in mobileSelectedAppl.versions" :key="vi">
                    <td>{{ ver.version }}</td>
                    <td>
                      <span v-if="ver.versionId">
                        {{ formatMoment(ver.versionId.startingDate) }} – {{ formatMoment(ver.versionId.endingDate) }}
                      </span>
                    </td>
                    <td>{{ ver.versionId && ver.versionId.numberOfDoors }}</td>
                    <td>{{ ver.versionId && ver.versionId.power ? `${ver.versionId.power.kw} kw` : '' }}</td>
                    <td>{{ ver.versionId && ver.versionId.engineCode }}</td>
                    <td>{{ ver.versionId ? getSupplyLocale(ver.versionId.supplyCode) : '' }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div class="text-center py-4">
              <v-btn color="red" variant="flat" @click="mobileSelectedAppl = null">
                {{ $t('close') }}
              </v-btn>
            </div>
          </div>
        </div>
        <!-- ═══════════════════════════════════════════════════════════════ -->

        <!--APPLICABILITY-->
        <v-card-actions class="d-none d-sm-block">
          <v-row no-gutters>
            <!-- Brand buttons -->
            <v-col cols="12">
              <div
                dense
                class="pa-2 d-flex flex-wrap"
                style="flex-wrap: wrap; gap: 8px"
              >
                <div
                  v-for="(brand, index) in uniqueBrands"
                  :key="index"
                  class="pa-0 d-inline-flex"
                >
                  <v-btn
                    text
                    variant="outlined"
                    color="black"
                    class="rounded-button"
                    :class="{ 'brand-button-selected': brandTabs === index }"
                    @click="onBrandClick(brand, index)"
                  >
                    {{ brand }}
                  </v-btn>
                </div>
              </div>
            </v-col>

            <!-- Model buttons -->
            <v-col cols="12">
              <v-row class="custom-tabs-row" no-gutters>
                <v-col
                  v-for="(model, index) in uniqueModels"
                  :key="index"
                  class="pt-2 pb-2 pl-2"
                  cols="auto"
                >
                  <v-btn
                    variant="outlined"
                    class="model-button"
                    :class="{ active: modelTabs === index }"
                    @click="onModelClick(model, index)"
                  >
                    {{ model }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>

            <!-- Years tabs -->
            <v-col cols="12" md="4">
              <v-tabs v-model="yearsTabs" color="primary">
                <v-tab
                  v-for="(year, index) in uniqueYears"
                  :key="index"
                  :value="index"
                  @click="onYearClick(year, index)"
                >
                  {{ formatMoment(year.startingDate) }} -
                  {{ formatMoment(year.endingDate) }}
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>
        </v-card-actions>

        <v-card-text class="d-none d-sm-block">
          <!-- <v-row > -->
          <v-row v-if="loading" justify-center>
            <v-progress-circular
              :size="75"
              color="red-darken-2"
              indeterminate
            />
          </v-row>
          <div v-if="applicability">
            <v-col cols="12" class="text-end justify-end d-flex">
              <v-btn
                v-if="customApplicability || part.customApplicability"
                variant="tonal"
                color="error"
              >
                {{ $t("custom_appl_info") }}
              </v-btn>
              <v-btn
                v-if="part.customApplicability"
                variant="outlined"
                color="error"
                class="mx-1"
                @click="editAppl()"
              >
                {{ $t("edit") }}
                <v-icon end> mdi-pencil </v-icon>
              </v-btn>
              <v-btn
                v-if="part.customApplicability"
                variant="outlined"
                color="error"
                class="mx-1"
                :loading="loadingCustomDelete"
                @click="openDeleteCustom()"
              >
                {{ $t("delete") }}
                <v-icon end> mdi-delete </v-icon>
              </v-btn>
            </v-col>
            <div v-if="openEditForm">
              <v-col class="d-flex py-0">
                <v-col xs="12" sm="6" xl="4" lg="4" md="4">
                  <v-autocomplete
                    v-model="editBrand"
                    :items="brands"
                    :loading="loadingBrand"
                    :label="$t('parts.advanced_search.brand')"
                    item-title="title"
                    item-value="brandCode"
                    variant="solo"
                    color="red-darken-1"
                    hide-details
                    return-object
                    clearable
                  >
                    <!-- Custom dropdown item -->
                    <template #item="{ props, item }">
                      <v-list-item v-bind="props">
                        <template #prepend>
                          <v-img
                            :src="item.raw.logo"
                            height="35"
                            width="35"
                            class="mr-3"
                            cover
                          />
                        </template>
                        <!-- <v-list-item-title>{{ item.raw.title }}</v-list-item-title> -->
                      </v-list-item>
                    </template>

                    <!-- Selected value in the field -->
                    <template #selection="{ item }">
                      <div class="d-flex align-center">
                        <v-img
                          :src="item.raw.logo"
                          height="35"
                          width="35"
                          class="mr-3"
                          cover
                        />
                        <span>{{ item.raw.title }}</span>
                      </div>
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col xs="12" sm="12" xl="8" lg="8" md="8">
                  <v-combobox
                    v-model="editModel"
                    :items="models"
                    :loading="loadingModel"
                    :label="!model ? $t('parts.advanced_search.model') : ''"
                    item-title="description"
                    item-value="modelCode"
                    variant="solo"
                    color="red-darken-1"
                    hide-details
                    return-object
                    clearable
                    @click:append-inner="model = null"
                  >
                    <!-- Dropdown items -->
                    <template #item="{ props, item }">
                      <v-list-item v-bind="props">
                        <v-list-item-content>
                          <div class="d-flex">
                            <!-- Description -->
                            <v-col
                              cols="12"
                              md="4"
                              class="bg-grey-lighten-3 mt-2"
                            >
                              <div class="d-flex flex-column">
                                <span class="caption">{{
                                  $t("parts.advanced_search.model")
                                }}</span>
                                <span class="font-weight-bold">{{
                                  item.raw.description
                                }}</span>
                              </div>
                            </v-col>

                            <!-- Year range -->
                            <v-col
                              cols="12"
                              md="8"
                              class="d-none d-md-flex bg-grey-lighten-3 mt-2"
                            >
                              <div class="d-flex flex-column">
                                <span class="caption">{{
                                  $t("parts.advanced_search.year")
                                }}</span>
                                <span class="font-weight-bold">
                                  {{ formatMonthYear(item.raw.startingDate) }}
                                  -
                                  {{ formatMonthYear(item.raw.endingDate) }}
                                </span>
                              </div>
                            </v-col>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </template>

                    <!-- Selected value -->
                    <template #selection="{ item }">
                      <div class="d-flex justify-between align-center pa-2">
                        <div class="d-flex flex-column pr-2">
                          <span class="caption">{{
                            $t("parts.advanced_search.model")
                          }}</span>
                          <span class="font-weight-bold">{{
                            item.raw.description
                          }}</span>
                        </div>
                        <div class="d-none d-md-flex flex-column">
                          <span class="caption">{{
                            $t("parts.advanced_search.year")
                          }}</span>
                          <span class="font-weight-bold">
                            {{ formatMonthYear(item.raw.startingDate) }} -
                            {{ formatMonthYear(item.raw.endingDate) }}
                          </span>
                        </div>
                      </div>
                    </template>
                  </v-combobox>
                </v-col>
              </v-col>
              <v-col>
                <v-col xs="12" sm="12" xl="12" lg="12" md="12">
                  <v-combobox
                    v-model="editVersion"
                    :items="versions"
                    :loading="loadingVersion"
                    :label="!version ? $t('parts.advanced_search.version') : ''"
                    item-title="fullDescription"
                    item-value="versionCode"
                    variant="solo"
                    color="red-darken-1"
                    hide-details
                    return-object
                    clearable
                    @click:append-inner="version = null"
                  >
                    <!-- Dropdown items -->
                    <template #item="{ item, props }">
                      <v-list-item v-bind="props">
                        <v-row class="pa-3 bg-grey-lighten-3 mt-2">
                          <v-col>
                            <v-row class="d-flex flex-column">
                              <span class="caption">{{
                                $t("parts.advanced_search.version")
                              }}</span>
                              <span class="font-weight-bold">{{
                                item.raw.description
                              }}</span>
                            </v-row>
                          </v-col>
                          <v-col class="hidden-sm-and-down">
                            <v-row class="d-flex flex-column">
                              <span class="caption">{{
                                $t("parts.advanced_search.year")
                              }}</span>
                              <span class="font-weight-bold">
                                {{ formatMonthYear(item.raw.startingDate) }} -
                                {{ formatMonthYear(item.raw.endingDate) }}
                              </span>
                            </v-row>
                          </v-col>
                          <v-col class="hidden-sm-and-down">
                            <v-row class="d-flex flex-column">
                              <span class="caption">{{
                                $t("parts.advanced_search.body")
                              }}</span>
                              <span class="font-weight-bold">{{
                                item.raw.numberOfDoors
                              }}</span>
                            </v-row>
                          </v-col>
                          <v-col class="hidden-sm-and-down">
                            <v-row class="d-flex flex-column">
                              <span class="caption">{{
                                $t("parts.advanced_search.power")
                              }}</span>
                              <span class="font-weight-bold">
                                {{ item.raw.power ? item.raw.power.kw : "" }}
                                kw,
                              </span>
                            </v-row>
                          </v-col>
                          <v-col class="hidden-sm-and-down">
                            <v-row class="d-flex flex-column">
                              <span class="caption">{{
                                $t("parts.advanced_search.engine")
                              }}</span>
                              <span class="font-weight-bold">{{
                                item.raw.engineCode
                              }}</span>
                            </v-row>
                          </v-col>
                          <v-col class="hidden-sm-and-down">
                            <v-row class="d-flex flex-column">
                              <span class="caption">{{
                                $t("parts.advanced_search.supply.supply")
                              }}</span>
                              <span class="font-weight-bold">{{
                                getSupplyLocale(item.raw.supplyCode)
                              }}</span>
                            </v-row>
                          </v-col>
                        </v-row>
                      </v-list-item>
                    </template>

                    <!--SELECTED-->
                    <template #selection="{ item }">
                      <v-row class="pa-2">
                        <v-col>
                          <v-row class="d-flex flex-column">
                            <span class="caption">
                              {{ $t("parts.advanced_search.version") }}
                            </span>
                            <span class="font-weight-bold">{{
                              item.raw.description
                            }}</span>
                          </v-row>
                        </v-col>
                        <v-col class="hidden-sm-and-down">
                          <v-row class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.year")
                            }}</span>
                            <span class="font-weight-bold">
                              {{ formatMonthYear(item.raw.startingDate) }} -
                              {{ formatMonthYear(item.raw.endingDate) }}
                            </span>
                          </v-row>
                        </v-col>
                        <v-col class="hidden-sm-and-down">
                          <v-row class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.body")
                            }}</span>
                            <span class="font-weight-bold">{{
                              item.raw.numberOfDoors
                            }}</span>
                          </v-row>
                        </v-col>
                        <v-col class="hidden-sm-and-down">
                          <v-row class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.power")
                            }}</span>
                            <span class="font-weight-bold">
                              {{ item.raw.power ? item.raw.power.kw : " " }}
                              kw,
                            </span>
                          </v-row>
                        </v-col>
                        <v-col class="hidden-sm-and-down">
                          <v-row class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.engine")
                            }}</span>
                            <span class="font-weight-bold">{{
                              item.raw.engineCode
                            }}</span>
                          </v-row>
                        </v-col>
                        <v-col class="hidden-sm-and-down">
                          <v-row class="d-flex flex-column">
                            <span class="caption">{{
                              $t("parts.advanced_search.supply.supply")
                            }}</span>
                            <span class="font-weight-bold">{{
                              getSupplyLocale(item.raw.supplyCode)
                            }}</span>
                          </v-row>
                        </v-col>
                      </v-row>
                    </template>
                  </v-combobox>
                </v-col>
                <v-col
                  xs="12"
                  sm="12"
                  xl="12"
                  lg="12"
                  md="12"
                  class="text-end justify-end d-flex"
                >
                  <v-btn
                    color="green darken-1"
                    variant="flat"
                    class="mx-1"
                    :loading="loadingEdit"
                    :disabled="!editBrand || !editModel || !editVersion"
                    @click="editCustomAppl()"
                  >
                    {{ $t("edit_custom_applicability") }}
                  </v-btn>
                </v-col>
              </v-col>
            </div>
            <v-col xs="12">
              <v-data-table
                v-if="
                  brandTabs !== null && modelTabs !== null && yearsTabs !== null
                "
                :headers="subheaders"
                :items="getFilteredVersions"
                class="inventoryDialogDatatable pb-10"
                :footer-props="{ 'items-per-page-options': [] }"
              >
                <template #item="{ item, index }">
                  <tr :class="{ tableRowColor: index === 0 }">
                    <td class="text-xs">
                      {{ item.version }}
                    </td>
                    <td class="text-xs">
                      <span v-if="item.versionId">
                        {{
                          formatMoment(item.versionId.startingDate)
                        }}&nbsp;-&nbsp;{{
                          formatMoment(item.versionId.endingDate)
                        }}
                      </span>
                    </td>
                    <td class="text-xs">
                      <span v-if="item.versionId"
                        >{{ item.versionId.numberOfDoors }}&nbsp;{{
                          $t("parts.infoCar.doors")
                        }}</span
                      >
                    </td>
                    <td class="text-xs">
                      <span v-if="item.versionId"
                        >{{
                          item.versionId && item.versionId.power
                            ? item.versionId.power.kw
                            : ""
                        }}
                        kw</span
                      >
                    </td>
                    <td class="text-xs">
                      <span v-if="item.versionId">{{
                        item.versionId.engineCode
                      }}</span>
                    </td>
                    <td class="text-xs">
                      <span v-if="item.versionId">{{
                        getSupplyLocale(item.versionId.supplyCode)
                      }}</span>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </div>
          <!-- </v-row> -->
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="acceptDeleteApplicabilityModal" persistent width="400">
      <v-card class="pa-3">
        <h3>
          <strong>
            {{ $t("parts.infoCar.confirm_delete_applicability") }}</strong
          >
        </h3>
        <br />
        <strong v-if="hasListings">{{
          $t("parts.infoCar.lisitngs_will_be_deleted")
        }}</strong>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="acceptDeleteApplicability()">
            {{ $t("parts.inventory.yes") }}
          </v-btn>
          <v-btn small @click="cancelDelete()">
            {{ $t("parts.inventory.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteCustomDialog" persistent width="400">
      <v-card class="pa-3">
        <h3>
          <strong>
            {{ $t("parts.infoCar.confirm_delete_applicability") }}</strong
          >
        </h3>
        <v-card-actions class="col-12 justify-end mt-2">
          <v-btn small @click="acceptDeleteCustomApplicability()">
            {{ $t("parts.inventory.yes") }}
          </v-btn>
          <v-btn small @click="cancelDeleteCustom()">
            {{ $t("parts.inventory.no") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import moment from "moment";
import getRequest from "../api/getRequest";
import deleteRequest from "../api/deleteRequest";
import postRequest from "../api/postRequest";
export default {
  filters: {
    moment(date) {
      moment.locale(localStorage.getItem("language"));
      const currentMonth = new Date().toISOString();
      return date
        ? moment(date).format("MM/YYYY")
        : moment(currentMonth).format("MM/YYYY");
    },
  },
  data: () => ({
    brandTabs: 0,
    modelTabs: 0,
    yearsTabs: 0,
    dialog: false,
    notifications: false,
    sound: true,
    expand: false,
    loading: false,
    loadingDelete: false,
    applicability: null,
    changeBrandIndex: 0,
    changeModelIndex: 0,
    car: null,

    headers: [
      { title: "Brand", sortable: false, value: "" },
      { title: "Model", sortable: false, value: "" },
      { title: "Year", sortable: false, value: "" },
    ],
    subheaders: [
      { title: "Version", sortable: false, value: "" },
      { title: "Year", sortable: false, value: "" },
      { title: "Body", sortable: false, value: "" },
      { title: "Power", sortable: false, value: "" },
      { title: "Engine", sortable: false, value: "" },
      { title: "Fuel", sortable: false, value: "" },
    ],
    part: {},
    acceptDeleteApplicabilityModal: false,
    customApplicability: false,
    loadingCustom: false,
    brand: null,
    model: null,
    version: null,
    brands: [],
    models: [],
    versions: [],
    loadingBrand: false,
    loadingModel: false,
    loadingVersion: false,
    addCustomForm: false,
    addFromOrigin: false,
    carBrand: null,
    carModel: null,
    carVersion: null,
    openEditForm: false,
    editBrand: null,
    editModel: null,
    editVersion: null,
    loadingEdit: false,
    deleteCustomDialog: false,
    prepopulatingEdit: false,
    mobileSelectedAppl: null,
  }),
  computed: {
    getFilteredVersions() {
      if (
        this.applicability === null ||
        this.uniqueYears[this.yearsTabs] === undefined
      ) {
        return [];
      }

      const brandTabs = this.uniqueBrands[this.brandTabs];
      const modelTabs = this.uniqueModels[this.modelTabs];

      const filteredData = this.applicability.filter(
        (item) =>
          item.brand === brandTabs &&
          item.modelId &&
          item.modelId.description === modelTabs, // Ensure modelId exists before accessing description
      );

      const selectedYear = this.uniqueYears[this.yearsTabs];
      if (
        !selectedYear ||
        selectedYear.startingDate === undefined ||
        selectedYear.endingDate === undefined
      ) {
        return [];
      }

      // Filter further by the selected year
      const filteredByYear = filteredData.filter(
        (item) =>
          item.modelId &&
          item.modelId.startingDate === selectedYear.startingDate &&
          item.modelId.endingDate === selectedYear.endingDate,
      );

      // Extract versions for the selected year
      const versions = filteredByYear.flatMap((item) => item.versions);

      return versions;
    },

    uniqueYears() {
      if (this.brandTabs !== null && this.modelTabs !== null) {
        if (this.applicability === null) {
          return [];
        }
        const brandTabs = this.uniqueBrands[this.brandTabs];
        const modelTabs = this.uniqueModels[this.modelTabs];

        // Filter the applicability data for the selected brand and model
        const filteredData = this.applicability.filter(
          (item) =>
            item.brand === brandTabs &&
            item.modelId &&
            item.modelId.description === modelTabs, // Ensure modelId exists before accessing description
        );

        // Extract and format unique starting and ending dates for years
        const years = [
          ...new Set(
            filteredData
              .filter((item) => item.modelId) // Ensure modelId exists
              .map((item) => ({
                startingDate: item.modelId.startingDate,
                endingDate: item.modelId.endingDate,
              })),
          ),
        ];

        return years;
      }
      return [];
    },

    uniqueBrands() {
      // Check if applicability is null before using map
      if (this.applicability === null) {
        return [];
      }

      return [...new Set(this.applicability.map((item) => item.brand))];
    },
    uniqueModels() {
      if (this.brandTabs !== null) {
        // Check if applicability is null before filtering
        if (this.applicability === null) {
          return [];
        }

        const brandTabs = this.uniqueBrands[this.brandTabs];

        const brandModels = this.applicability
          .filter(
            (item) =>
              item.brand === brandTabs &&
              item.modelId &&
              item.modelId.description,
          ) // Ensure modelId and description exist
          .map((item) => item.modelId.description);

        return [...new Set(brandModels)];
      }
      return [];
    },

    getFilteredApplicability() {
      if (this.brandTabs !== null && this.modelTabs !== null) {
        if (this.applicability === null) {
          return [];
        }

        const brandTabs = this.uniqueBrands[this.brandTabs];
        const modelTabs = this.uniqueModels[this.modelTabs];

        return this.applicability.filter(
          (item) =>
            item.brand === brandTabs &&
            item.modelId && // Ensure modelId exists
            item.modelId.description === modelTabs,
        );
      }
      return this.applicability || [];
    },

    hasListings() {
      return (
        this.part &&
        this.part.eBayListings &&
        Object.values(this.part.eBayListings).some(
          (countryListings) => countryListings.length > 0,
        )
      );
    },
  },
  watch: {
    dialog(value) {
      if (!value) {
        this.close();
      }
    },
    brand(value) {
      if (value) {
        this.models = [];
        this.model = null;
        this.versions = [];
        this.version = null;
        // Make sure that we don't get the models if we are searching for a license plate.

        // this.brand = value.brandCode;
        this.getModels(value.brandCode);
      } else {
        // this.brand = null;
      }
    },
    model(value) {
      if (value) {
        this.versions = [];
        this.version = null;
        // Make sure that we don't get the versions if we are searching for a license plate.
        this.getVersions(value.brandCode, value.modelCode);
        // this.model = value.modelCode;
        // Set year rule.
        this.setYearRule(value.startingDate, value.endingDate);
      } else {
        this.model = null;
      }
    },
    version(value) {
      if (value) {
        // this.version = value.versionCode;
        // Set year rule.
        this.setYearRule(value.startingDate, value.endingDate);
      } else {
        this.version = null;
      }
    },
    editBrand(value) {
      if (!this.prepopulatingEdit) {
        this.editModel = null;
        this.editVersion = null;
      }
      if (value) {
        this.models = [];
        this.editBrand = value.brandCode ? value.brandCode : value;
        let br = value.brandCode ? value.brandCode : value;
        this.getModels(br);
      }
    },
    editModel(value) {
      if (!this.prepopulatingEdit) {
        this.editVersion = null;
      }
      if (value) {
        this.versions = [];
        let br = this.editBrand.brandCode
          ? this.editBrand.brandCode
          : this.editBrand;
        let md = value.modelCode ? value.modelCode : value;
        this.getVersions(br, md);
      }
    },
    editVersion(value) {
      if (value) {
        this.editVersion = value.versionCode ? value.versionCode : value;
      }
    },
  },
  created() {
    this.getLocale();
    this.getBrands();
    this.setYearRule();
  },
  methods: {
    formatMoment(date) {
      moment.locale(localStorage.getItem("language"));
      // const currentMonth = new Date().toISOString();
      return date ? moment(date).format("MM/YYYY") : "";
    },
    onYearClick(index) {
      if (index < this.uniqueYears.length) {
        this.yearsTabs = index;
      }
    },
    onModelClick(model, index) {
      if (index < this.uniqueModels.length) {
        this.modelTabs = index;
      }
      this.yearsTabs = 0;
    },
    onBrandClick(brand, index) {
      this.brandTabs = index;
      this.modelTabs = 0;
      this.yearsTabs = 0;
    },
    open(data) {
      this.dialog = true;
      if (data && data.customApplicability) {
        this.getCustomApplicability(data._id);
      }
      if (data.infoCar && data.infoCar._id)
        this.getInfoCarDetails(data.infoCar._id);
      if (data.car_id) {
        this.getCarDetails(data.car_id);
      }
      this.part = data;
      // Reset tabs to the first options when opening a new applicability
      this.brandTabs = 0;
      this.modelTabs = 0;
      this.yearsTabs = 0;
    },
    getInfoCarDetails(id) {
      this.loading = true;
      getRequest(`/info-car/id/${id}`)
        .then((response) => {
          if (response && response.applicability) {
            this.applicability = response.applicability;
          } else if (response && response.customApplicability) {
            this.customApplicability = response.customApplicability;
          }
        })
        .catch(() => (this.loading = false))
        .finally(() => {
          this.loading = false;
        });
    },
    getCarDetails(id) {
      this.loading = true;
      getRequest("/car/", `id=${id}`)
        .then((response) => {
          this.car = response.car;
        })
        .catch(() => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
      this.applicability = null;
      this.loading = false;
      this.loadingDelete = false;
      this.part = {};
      this.car = null;
      this.addCustomForm = false;
      this.addFromOrigin = false;
      this.brand = null;
      this.model = null;
      this.version = null;
      this.carBrand = null;
      this.carModel = null;
      this.carVersion = null;
      this.editBrand = null;
      this.editModel = null;
      this.editVersion = null;
      this.openEditForm = false;
      this.loadingCustom = false;
      this.loadingEdit = false;
      this.mobileSelectedAppl = null;
      this.$emit("close");
    },
    getLocale() {
      this.headers[0].title = this.$t("parts.infoCar.brand");
      this.headers[1].title = this.$t("parts.infoCar.model");
      this.headers[2].title = this.$t("parts.infoCar.year");
      this.subheaders[0].title = this.$t("parts.infoCar.version");
      this.subheaders[1].title = this.$t("parts.infoCar.year");
      this.subheaders[2].title = this.$t("parts.infoCar.body");
      this.subheaders[3].title = this.$t("parts.infoCar.power");
      this.subheaders[4].title = this.$t("parts.infoCar.engine");
      this.subheaders[5].title = this.$t("parts.infoCar.supply.title");
    },
    deleteApplicability() {
      this.acceptDeleteApplicabilityModal = true;
    },
    acceptDeleteApplicability() {
      this.loadingDelete = true;
      deleteRequest("/part/applicability", `id=${this.part._id}`)
        .then((response) => {
          if (response) {
            this.$emit("delete-applicability");
            this.close();
          }
        })
        .catch(() => {
          this.loadingDelete = false;
          this.acceptDeleteApplicabilityModal = false;
        })
        .finally(() => {
          this.loadingDelete = false;
          this.acceptDeleteApplicabilityModal = false;
        });
    },
    cancelDelete() {
      this.acceptDeleteApplicabilityModal = false;
    },
    setYearRule(startingDate, endingDate) {
      const startingYear = startingDate
        ? new Date(startingDate).getFullYear()
        : 1900;
      const endingYear = endingDate
        ? new Date(endingDate).getFullYear()
        : new Date().getFullYear();
      this.yearRule = (v) =>
        (v >= startingYear && v <= endingYear) ||
        this.$t("parts.advanced_search.year_error");
    },

    getBrands() {
      this.loadingBrand = true;
      getRequest("/info-car/brands")
        .then((response) => {
          this.brands = response.brands;
        })
        .catch(() => {})
        .finally(() => {
          this.loadingBrand = false;
        });
    },
    getModels(brandCode) {
      this.loadingModel = true;
      getRequest("/info-car/models", `brand_code=${brandCode}`)
        .then((response) => {
          this.models = response.models;
          this.filterModels();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingModel = false;
        });
    },
    getVersions(brandCode, modelCode) {
      this.loadingVersion = true;
      getRequest(
        "/info-car/versions",
        `brand_code=${brandCode}&model_code=${modelCode}`,
      )
        .then((response) => {
          this.versions = response.versions;
          this.filterVersions();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingVersion = false;
        });
    },
    filterModels() {
      if (
        this.year &&
        this.year.length === 4 &&
        this.models &&
        this.models.length > 0
      ) {
        this.models = this.models.filter((model) => {
          const sYear = model.startingDate
            ? new Date(model.startingDate).getFullYear()
            : 1900;
          const eYear = model.endingDate
            ? new Date(model.endingDate).getFullYear()
            : new Date().getFullYear();

          return this.year >= sYear && this.year <= eYear;
        });
      }
    },
    filterVersions() {
      if (
        this.brand &&
        this.brand.brandCode &&
        this.model &&
        this.model.modelCode &&
        this.versions &&
        this.versions.length > 0
      ) {
        if (this.year) {
          // filter by year
          this.versions = this.versions.filter((version) => {
            const sYear = version.startingDate
              ? new Date(version.startingDate).getFullYear()
              : 1900;
            const eYear = version.endingDate
              ? new Date(version.endingDate).getFullYear()
              : new Date().getFullYear();

            return this.year >= sYear && this.year <= eYear;
          });
        }

        if (this.supply) {
          // filter by supply
          this.versions = this.versions.filter(
            (version) => version.supplyCode === this.supply,
          );
        }
      }
    },
    formatMonthYear(dateString) {
      if (!dateString) return "";
      const date = new Date(dateString);
      const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // months are 0-indexed
      const year = date.getUTCFullYear();
      return `${month}/${year}`;
    },
    getSupplyLocale(supply) {
      switch (supply) {
        case "B":
          return this.$t("parts.advanced_search.supply.petrol");
        case "D":
          return this.$t("parts.advanced_search.supply.diesel");
        case "G":
          return this.$t("parts.advanced_search.supply.gas");
        default:
          return supply;
      }
    },
    openCustomAppl() {
      this.addCustomForm = !this.addCustomForm;
    },
    async openOriginAppl() {
      if (this.car) {
        this.carBrand = this.car.brand.title;
        this.carModel = this.car.model.fullDescription;
        this.carVersion = this.car.version.fullDescription;
        this.addFromOrigin = !this.addFromOrigin;
      }
    },
    addCustomApplicability() {
      this.loadingCustom = true;
      let data = {
        brandCode: this.brand.brandCode,
        modelCode: this.model.modelCode,
        versionCode: this.version.versionCode,
      };
      postRequest
        .object(`/part/custom-applicability/${this.part._id}`, data)
        .then((response) => {
          if (response) {
            this.part = response.data;
            this.getCustomApplicability(response.data._id);
            this.loadingCustom = false;
            this.addCustomForm = false;
            this.addFromOrigin = false;
          }
        })
        .catch(() => {
          this.loadingCustom = false;
          this.addCustomForm = false;
          this.addFromOrigin = false;
        })
        .finally(() => {
          this.loadingCustom = false;
          this.addCustomForm = false;
          this.addFromOrigin = false;
        });
    },
    addOriginApplicability() {
      this.loadingCustom = true;
      let data = {
        brandCode: this.car.brand.brandCode,
        modelCode: this.car.model.modelCode,
        versionCode: this.car.version.versionCode,
      };
      postRequest
        .object(`/part/custom-applicability/${this.part._id}`, data)
        .then((response) => {
          if (response) {
            this.part = response.data;
            this.getCustomApplicability(response.data._id);
            this.loadingCustom = false;
            this.addCustomForm = false;
            this.addFromOrigin = false;
          }
        })
        .catch(() => {
          this.loadingCustom = false;
          this.addCustomForm = false;
          this.addFromOrigin = false;
        })
        .finally(() => {
          this.loadingCustom = false;
          this.addCustomForm = false;
          this.addFromOrigin = false;
        });
    },
    getCustomApplicability(id) {
      this.loading = true;
      getRequest(`/part/custom-applicability/${id}`)
        .then((response) => {
          if (response && response.applicability) {
            this.applicability = response.applicability;
          }
        })
        .catch(() => (this.loading = false))
        .finally(() => {
          this.loading = false;
        });
    },
    async editAppl() {
      this.prepopulatingEdit = true;
      let carInfo = this.part.infoCar.metadata[0];
      this.editBrand = carInfo.brand;
      this.editModel = carInfo.model;
      this.editVersion = carInfo.version;
      this.openEditForm = !this.openEditForm;
      this.$nextTick(() => {
        this.prepopulatingEdit = false;
      });
    },
    editCustomAppl() {
      this.loadingEdit = true;
      let data = {
        brandCode: this.editBrand,
        modelCode: this.editModel,
        versionCode: this.editVersion,
      };
      postRequest
        .object(`/part/custom-applicability/${this.part._id}`, data)
        .then((response) => {
          if (response) {
            this.part = response.data;
            this.getCustomApplicability(response.data._id);
            this.loadingEdit = false;
            this.openEditForm = false;
          }
        })
        .catch(() => {
          this.loadingEdit = false;
          this.openEditForm = false;
        })
        .finally(() => {
          this.loadingEdit = false;
          this.openEditForm = false;
        });
    },
    openDeleteCustom() {
      this.deleteCustomDialog = true;
    },
    cancelDeleteCustom() {
      this.loadingCustomDelete = false;
      this.deleteCustomDialog = false;
    },
    acceptDeleteCustomApplicability() {
      this.loadingCustomDelete = true;
      deleteRequest(`/part/custom-applicability/`, `id=${this.part._id}`)
        .then((response) => {
          console.log("res", response);
          if (response && response.data) {
            this.part = response.data;
            this.applicability = null;
          }
        })
        .catch(() => {
          this.loadingCustomDelete = false;
          this.deleteCustomDialog = false;
        })
        .finally(() => {
          this.loadingCustomDelete = false;
          this.deleteCustomDialog = false;
        });
    },
  },
};
</script>

<style scoped>
.details-applicability-toolbar :deep(.v-toolbar__content) {
  align-items: stretch;
  height: auto !important;
  max-width: 100%;
  flex-wrap: wrap;
}

@media (min-width: 960px) {
  .details-applicability-toolbar :deep(.v-toolbar__content) {
    flex-wrap: nowrap;
  }
}

.custom-tabs-row {
  background-color: white;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  box-shadow: none !important;
}

.model-button {
  height: 48px;
  background-color: white !important;
  background: white !important;
  border-radius: 0;
  font-weight: 500;
  border: none;
  color: #333;
  text-transform: none;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: none !important;
  opacity: 0.7;
}

.model-button.active {
  background-color: white !important;
  color: rgba(0, 0, 0, 0.87);
  border-bottom: 2px solid #42a5f5;
  box-shadow: none !important;
  opacity: 1;
}

:deep(.inventoryDialogDatatable thead th) {
  background-color: #000000 !important; /* Black background */
  color: #ffffff !important; /* White text */
}
.v-btn--active:before,
.v-btn:hover:before,
.v-btn:focus:before {
  background-color: white !important;
}
@media (min-width: 960px) {
  .deleteApplicability {
    margin-right: 38px;
  }

  /* Keep car details on one row from md up (same overall layout as before) */
  .car-details-row {
    flex-wrap: nowrap !important;
  }

  .car-details-model,
  .car-details-version {
    flex: 1 1 0%;
    min-width: 0;
  }
}

/* Mobile / narrow: stack fields; allow long version/model text to wrap */
.car-details-row {
  flex-wrap: wrap;
}

.car-details-cell {
  min-width: 0;
}


/* ── Mobile car details ── */
.car-details-mobile__row {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 2px;
}
.car-details-mobile__label {
  font-size: 0.75rem;
  color: #757575;
  white-space: nowrap;
}
.car-details-mobile__value {
  font-size: 0.85rem;
  font-weight: 600;
}

/* ── Mobile applicability list ── */
.appl-mobile-row {
  cursor: pointer;
  transition: background 0.15s;
}
.appl-mobile-row:active {
  background: #f5f5f5;
}

/* ── Mobile version detail table ── */
.appl-mobile-version-table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  font-size: 0.72rem;
}
.appl-mobile-version-table th,
.appl-mobile-version-table td {
  padding: 6px 4px;
  vertical-align: top;
  word-break: break-word;
}
.appl-mobile-version-table th {
  background: #000;
  color: #fff;
  text-align: left;
  white-space: nowrap;
}
.appl-mobile-version-table td {
  border-bottom: 1px solid #eee;
}
/* Column widths: Versione gets more space, small cols for Corpo/Potenza */
.appl-mobile-version-table th:nth-child(1),
.appl-mobile-version-table td:nth-child(1) { width: 28%; }
.appl-mobile-version-table th:nth-child(2),
.appl-mobile-version-table td:nth-child(2) { width: 20%; }
.appl-mobile-version-table th:nth-child(3),
.appl-mobile-version-table td:nth-child(3) { width: 12%; }
.appl-mobile-version-table th:nth-child(4),
.appl-mobile-version-table td:nth-child(4) { width: 12%; }
.appl-mobile-version-table th:nth-child(5),
.appl-mobile-version-table td:nth-child(5) { width: 14%; }
.appl-mobile-version-table th:nth-child(6),
.appl-mobile-version-table td:nth-child(6) { width: 14%; }
</style>
